
// Cognitoのエラーによって、メッセージを変える
export function switchCognitoError(error) {
	let message = "エラーが発生しました。";
	if (typeof error === "string") {
		message = error
		switch (error) {
			case "Cannot reset password for the user as there is no registered/verified email or phone_number":
				message = "ユーザーのメールアドレスが有効化されていない可能性があります。お手数ですがご確認のうえ、再度お試しください。"
				break;
			case "Unauthenticated access is not supported for this identity pool.":
				message = "ユーザー名かパスワードが違います。お手数ですが入力内容を見直し、再度お試しください。"
				break;
			case "User password cannot be reset in the current state.":
				message = "ユーザーのメールアドレスが有効化されていないか、初回サインインがされていない可能性があります。お手数ですがご確認のうえ、再度お試しください。"
				break;
			case "Incorrect username or password.":
				message = "ユーザー名かパスワードが違います。お手数ですが入力内容を見直し、再度お試しください。"
				break;
			case "Invalid code received for user":
				message = "ワンタイムパスワードが正しくありません。お手数ですが入力内容を見直し、再度お試しください。"
				break;
			case "Password attempts exceeded":
				message = "パスワードの試行回数が上限に達しました。お手数ですが時間を置いて、再度お試しください。"
				break;
			case "Invalid session for the user, session can only be used once.":
				message = "内部エラーが発生しました。お手数ですが時間を置くか、ブラウザを更新して再度お試しください。"
				break;
			case "Temporary password has expired and must be reset by an administrator.":
				message = "パスワードの有効期限が切れています。お手数ですが管理者にお問い合わせください。"
				break;
			case "Invalid session for the user, session is expired.":
				message = "セッションの有効期限が切れています。お手数ですがブラウザを更新して再度お試しください。"
				break;
			case "Attempt limit exceeded, please try after some time.":
				message = "リクエスト回数が多すぎます。お手数ですが時間を置いて、再度お試しください。"
				break;
			case "Invalid code received for user":
				message = "ワンタイムパスワードが正しくありません。お手数ですが入力内容を見直し、再度お試しください。"
				break;
			case "Your verification code has expired. Please request a new code.":
				message = "ワンタイムパスワードの有効期限が切れています。お手数ですがワンタイムパスワードを更新し、再度お試しください。"
				break;
			case "Invalid code provided, please request a code again.":
				message = "ワンタイムパスワードの有効期限が切れています。お手数ですがワンタイムパスワードを更新し、再度お試しください。"
				break;
			case "Your software token has already been used once.":
				message = "既に一度使用されたワンタイムパスワードです。お手数ですがワンタイムパスワードを更新し、再度お試しください。"
				break;
			case "Invalid verification code provided, please try again.":
				message = "ワンタイムパスワードが正しくありません。お手数ですが入力内容を見直し、再度お試しください。"
				break;
			case "Code mismatch":
				message = "ワンタイムパスワードが正しくありません。お手数ですが入力内容を見直し、再度お試しください。"
				break;
			default:
				message = "内部エラーが発生しました。お手数ですが時間を置くか、ブラウザを更新して再度お試しください。"
				break;
		}
	}
	return message
}

